import toArray from 'lodash/toArray';
import get from 'lodash/get';
import forEach from 'lodash/forEach';

import { getControlDescriptionForType } from '~lib/case-logic-builder/utils/getControlForType';
import ACTION_CONTROLS from '~lib/case-logic-builder/ACTION_CONTROLS';
import EFFECT_CONTROLS from '~lib/case-logic-builder/EFFECT_CONTROLS';
import CHECK_CONTROLS from '~lib/case-logic-builder/CHECK_CONTROLS';

function validateControlTypes(caseConf) {
  const nodes = toArray(get(caseConf, 'caseLogicDescription.nodes'));
  const errors = [];
  const warnings = [];

  nodes.forEach((node) => {
    if (node.name === 'Action') {
      const action = get(node, 'data.action') || {};
      if (getControlDescriptionForType(action.type, action, ACTION_CONTROLS).invalid) {
        errors.push(invalidControlError(node.id));
      }
    } else if (node.name === 'Effect') {
      const effect = get(node, 'data.effect') || {};
      if (getControlDescriptionForType(effect.type, effect, EFFECT_CONTROLS).invalid) {
        errors.push(invalidControlError(node.id));
      }
    } else if (node.name === 'Check') {
      forEach(node.data, (check) => {
        if (check.id &&
            getControlDescriptionForType(check.type, check, CHECK_CONTROLS).invalid) {
          errors.push(invalidControlError(node.id));
        }
      });
    }
  });
  return {
    errors,
    warnings,
  };
}

function invalidControlError(nodeId) {
  return {
    message: 'Unrecognized node component found.',
    category: 'caseLogic',
    field: 'caseLogicDescription',
    id: nodeId,
  };
}

export default validateControlTypes;
